import React, { useState } from "react";
import { motion } from "framer-motion";

const TransferRejectReasonModal = ({ open, item, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <motion.div
        className="bg-white rounded-xl p-6 w-full max-w-sm shadow-2xl"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -40 }}
      >
        <h3 className="text-lg font-semibold text-[#6b59c6] mb-2">
          Reject Item {item.itemCode}
        </h3>
        <p className="text-xs text-gray-600 mb-3">
          Please provide a reason for rejecting this item.
        </p>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter reason..."
          className="w-full border rounded-md p-2 text-sm h-24"
        />
        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1.5 bg-gray-200 text-gray-800 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={() => onSubmit(reason)}
            className="px-3 py-1.5 bg-rose-600 text-white rounded-md"
            disabled={!reason.trim()}
          >
            Reject
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default TransferRejectReasonModal;
